import Layout from '@layout/Index'

export const batchJobsRouter = [
  {
    path: '/batch-jobs',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'all-batch-jobs-table',
      },
      {
        path: 'all-batch-jobs-table',
        component: () => import(/* webpackChunkName: "all-batch-jobs-table" */ './pages/AllBatchJobsTable.vue'),
        name: '所有批量任务列表',
        meta: {
          title: '所有批量任务列表',
        },
      },
      {
        path: 'finance-export-jobs',
        component: () => import(/* webpackChunkName: "finance-export-jobs" */ './pages/FinanceBatchJobTable.vue'),
        name: '财务数据导出任务',
        meta: {
          title: '财务数据导出任务',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/batch-jobs/batch-jobs.route.js